import Modal from 'components/common/modal';
import Button from 'components/inputs/button';
import LabelButton from 'components/inputs/label-button';
import UploadedImagesGrid from 'components/structure-page/lists/uploaded-images-grid';
import { useId, useState } from 'react';

const EXAMPLE_IMAGES = [
  { id: 'layout-sketch', url: 'sketch-example.jpg', name: 'Hand Drawn Sketch' },
  { id: 'floorplan', url: 'floorplan-example.jpg', name: 'Floor Plan' },
  {
    id: 'phone-photo',
    url: 'ai-example.png',
    name: 'Photo Uploaded From Phone'
  }
];

type LayoutImagesUploadStepProps = Readonly<{
  onImageUpload: (files: File[]) => void;
  onOpenPhotoCollector: () => void;
  isUploading?: boolean;
}>;

export default function LayoutImagesUploadStep({
  onImageUpload,
  onOpenPhotoCollector,
  isUploading = false
}: LayoutImagesUploadStepProps) {
  const fileInputId = useId();
  const [examplesOpen, setExamplesOpen] = useState(false);

  return (
    <div className='flex w-full flex-col gap-3 p-4'>
      <p className='text-center text-lg font-semibold text-gray-800'>
        Layout Images
      </p>
      <div className='flex w-full flex-col items-center gap-4 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 px-8 py-4 text-center'>
        <input
          id={fileInputId}
          type='file'
          accept='image/*,application/pdf'
          onChange={(e) => {
            const { files } = e.currentTarget;
            if (files && files.length > 0) {
              const captured = Array.from(files);
              e.currentTarget.value = '';
              onImageUpload(captured);
            } else {
              e.currentTarget.value = '';
            }
          }}
          className='hidden'
          multiple
        />
        <UploadedImagesGrid />
        <div className='flex flex-wrap items-center justify-center gap-3'>
          <LabelButton
            text='Upload From Computer'
            htmlFor={fileInputId}
            color='white'
            loading={isUploading}
            disabled={isUploading}
          />
          <span className='text-sm text-gray-500'>or</span>
          <Button
            text='Upload from your phone'
            onClick={onOpenPhotoCollector}
            color='white'
          />
        </div>
        <button
          type='button'
          className='text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline'
          onClick={() => setExamplesOpen(true)}
        >
          See Examples
        </button>
      </div>

      <Modal
        openState={[examplesOpen, setExamplesOpen]}
        title='Layout Image Examples'
        size='wide'
        infoMode
      >
        <div className='flex flex-wrap items-start justify-center gap-4'>
          {EXAMPLE_IMAGES.map((example) => (
            <div key={example.id} className='flex flex-col items-center gap-1'>
              <img
                className='h-[300px] w-[300px] rounded object-scale-down'
                src={`images/structure/${example.url}`}
                alt={example.name}
              />
              <span className='text-sm font-medium text-gray-700'>
                {example.name}
              </span>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}
